import React, { Component } from 'react'
import { graphql } from 'gatsby'
import styled, { css } from 'styled-components'
import Img from 'gatsby-image'
import {
  Row,
  Col,
  Gap,
  Text,
  Section,
  Title,
  Button,
  VH,
  HpTop,
  Fill,
  BusinessTripSection,
  HopSection,
  BeachSection,
  SEO,
} from '../components'
import { up, addResponsivity } from '../lib/styles'

import multicopterImageSrc from '../data/images/usage/multicopter.jpg'
import zuriImageSrc from '../data/images/usage/zuri.png'
import planeImageSrc from '../data/images/usage/plane.jpg'

const PlaneImageWrapper = styled.div`
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
  }
`

class Usage extends Component {
  render() {
    const {
      location: { pathname },
      data: { businessTripImage, hopImage, beachImage },
    } = this.props
    return (
      <>
        <SEO
          title="Uses | Zuri"
          description="We are developing a modern private aircraft with vertical takeoff and landing. This will allow you to affordably travel from city to city at distances of up to 700 km apart."
          pathname={pathname}
        />
        <Gap.Top />
        <BusinessTripSection bgImage={businessTripImage} />
        <Gap gap="150px" mobileGap="0" bp="tablet" />
        <Gap gap="50px" showBelow={1380} />
        <Gap gap="50px" showBelow={1140} />
        <HopSection bgImage={hopImage} />
        <Gap gap="100px" mobileGap="0" />
        <BeachSection bgImage={beachImage} />

        <Section background="#000000">
          <Col alignItems="center">
            <Gap gap="100px" mobileGap="60px" bp="tablet" />
            <Title.Usage mobileFontSize="26px">TYPICAL USE CASES</Title.Usage>
            <Gap gap="100px" mobileGap="60px" bp="tablet" />
            <Row
              justifyContent="space-evenly"
              width="100%"
              wrap="nowrap"
              mobileFlexDirection="column"
            >
              <Col basis="33%">
                <PlaneImageWrapper>
                  <img src={multicopterImageSrc} alt="Multicopter" />
                </PlaneImageWrapper>
                <Title.UsagePlaneType white>MULTICOPTERS</Title.UsagePlaneType>
                <Gap gap="15px" />
                <Text.UseCaseDescription>Urban Air Mobility, short range</Text.UseCaseDescription>
              </Col>
              <Gap gap="10px" mobileGap="80px" />
              <Col basis="33%">
                <PlaneImageWrapper>
                  <img src={zuriImageSrc} alt="Zuri" />
                </PlaneImageWrapper>
                <Title.UsagePlaneType white>ZURI</Title.UsagePlaneType>
                <Gap gap="15px" />
                <Text.UseCaseDescription>Between cities, medium range</Text.UseCaseDescription>
              </Col>
              <Gap gap="10px" mobileGap="80px" />
              <Col basis="33%">
                <PlaneImageWrapper>
                  <img src={planeImageSrc} alt="Airliner" />
                </PlaneImageWrapper>
                <Title.UsagePlaneType white>AIRLINERS</Title.UsagePlaneType>
                <Gap gap="15px" />
                <Text.UseCaseDescription>Long range, even intercontinental</Text.UseCaseDescription>
              </Col>
            </Row>
          </Col>
          <Gap gap="150px" mobileGap="50px" />
        </Section>
      </>
    )
  }
}

export default Usage

export const pageQuery = graphql`
  query {
    businessTripImage: file(relativePath: { eq: "images/usage/bg1.jpg" }) {
      ...FullHdImage
    }
    hopImage: file(relativePath: { eq: "images/usage/bg2.jpg" }) {
      ...FullHdImage
    }
    beachImage: file(relativePath: { eq: "images/usage/bg3.jpg" }) {
      ...FullHdImage
    }
  }
`
